import { LitElement } from 'lit'

class HHElement extends LitElement {
  constructor() {
    super()
  }

  queryChildren(root, selector = "*", maxLength, items = []) {
    const _root = root ?? this

    const cutQuery = () => {
      items = items.filter(i => i).filter((item, index) => items.indexOf(item) === index)
      if (maxLength && items.length >= maxLength) {
        items = items.slice(0, maxLength)
        return true;
      }
    }

    if (_root.matches(selector)) {
      items.push(_root)
    }

    if (_root.shadowRoot) {
      items = [...items, ...(_root.shadowRoot?.querySelectorAll?.(selector) ?? [])]
    }

    if (cutQuery()) return items;
    
    if (_root.tagName === 'SLOT') {
      const assignedNodes = _root
        .assignedNodes()
        .filter((node) => node.nodeType === 1)
      if (assignedNodes.length > 0) {
        for (const node of assignedNodes) {
          items = [...items, ...this.queryChildren(node, selector, maxLength, items)]
        }
      }
    }

    if (cutQuery()) return items;

    for (const child of [...(_root.renderRoot?.children ?? []), ...(_root.children ?? [])]) {
      items = this.queryChildren(child, selector, maxLength, items)
    }

    cutQuery();

    return items;
  }

  querySelectorAll(selector = "*") {
    return this.queryChildren(this, selector)
  }

  querySelector(selector) {
    return this.queryChildren(this, selector, 1)[0]
  }
}

export default HHElement